// extracted by mini-css-extract-plugin
export default {"group":"time-group_group__CoT0P","time":"time-group_time__TlrLG","divider":"time-group_divider__ZaF5w"};